export default __webpack_public_path__ + "static/media/no-image-available.002f8622.png";